// extracted by mini-css-extract-plugin
module.exports = {"chatBotBody":"styles_chatBotBody__Tec5c","chatBotIcon":"styles_chatBotIcon__3-lH0"};